import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

export interface AdvanceActivityRow {
  id: number;
  kind: 'transaction' | 'payment';
  date: string;
  title: string;
  description: string;
  amount: string;
  status:
    | 'Scheduled'
    | 'Processing'
    | 'Paid'
    | 'Failed'
    | 'Canceled'
    | 'Returned';
}
export interface AdvanceTransactionDetail extends AdvanceActivityRow {
  dealId: number;
  deal: string;
  from: { name: string; type: 'deal' | 'bank' | 'card' | 'merchant' };
  to: { name: string; type: 'deal' | 'bank' | 'card' | 'merchant' };
  method: string;
  summary: string;
  alert: string | null;
  breakdown: {
    label: string;
    amount: string;
    note?: string;
    total?: boolean;
  }[];
  repaymentNote: string | null;
  timeline: {
    label: string;
    date: string | null;
    state: 'done' | 'current' | 'future' | 'failed';
    note?: string;
  }[];
  references: { label: string; value: string | null }[];
  canRetry: boolean;
  retrySubmitted?: boolean;
  refreshPending?: boolean;
  retryUnavailableReason: string | null;
}
@Injectable({ providedIn: 'root' })
export class AdvanceTransactionService {
  constructor(private readonly http: HttpClient) {}
  activity(dealId: number): Observable<AdvanceActivityRow[]> {
    return this.http.get<AdvanceActivityRow[]>(
      `${environment.apiUrlToken}/api/advance-transactions/${dealId}`,
    );
  }
  detail(
    dealId: number,
    kind: string,
    id: number,
  ): Observable<AdvanceTransactionDetail> {
    return this.http.get<AdvanceTransactionDetail>(
      `${environment.apiUrlToken}/api/advance-transactions/${dealId}/${kind}/${id}`,
    );
  }
}
